import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { QuotationModalComponent } from '../../modals/quotation-modal/quotation-modal.component';
import { AuthenticationService } from 'src/app/shared/services';
import { QuotationModalMobileComponent } from '../../modals/quotation-modal/quotation-modal-mobile/quotation-modal-mobile.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-create-order-confirm-quotation',
  templateUrl: './create-order-confirm-quotation.component.html',
  styleUrls: ['./create-order-confirm-quotation.component.scss'],
})
export class CreateOrderConfirmQuotationComponent implements OnInit {
  boobleModalData: any;
  moedas = Moedas;
  isMobile: boolean;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private modalService: BoobleModalService,
    private matIconRegistry: MatIconRegistry,
    private bottomSheet: MatBottomSheet,
    private readonly accountService: AuthenticationService,
    private domSanitzer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/sucess.svg')
    );
  }
  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820 ? true : false;
    if (!this.boobleModalData) throw new Error('modal data is undefined');
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openQuotation() {
    if (!this.isMobile) {
      this.modalService.present(QuotationModalComponent, {
        orderType: this.boobleModalData.orderType,
        finality: this.boobleModalData.finality,
        amount: this.boobleModalData.amount,
        country: this.boobleModalData.country,
        orderId: this.boobleModalData.orderId,
        currency: this.moedas.find(
          (moeda) => moeda.id === this.boobleModalData.currencyId
        ),
      });
    } else {
      const bottomSheetConfig = {
        data: {
          orderType: this.boobleModalData.orderType,
          finality: this.boobleModalData.finality,
          amount: this.boobleModalData.amount,
          country: this.boobleModalData.country,
          orderId: this.boobleModalData.orderId,
          currency: this.moedas.find(
            (moeda) => moeda.id === this.boobleModalData.currencyId
          ),
        },
      };
      this.bottomSheet.open(QuotationModalMobileComponent, bottomSheetConfig);
    }
  }
}
